export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vaxicare-backend.projectanddemoserver.com/api/v1';
